import { render, staticRenderFns } from "./IndustryPreference.vue?vue&type=template&id=4ce712ca"
import script from "./IndustryPreference.vue?vue&type=script&lang=js"
export * from "./IndustryPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports